import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.singleButton ? _c('core-split-button', [_c(VMenu, {
    attrs: {
      "max-height": "400",
      "offset-y": "",
      "close-on-click": true,
      "close-on-content-click": false,
      "nudge-bottom": "4"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_vm.iconOnly ? _c('core-button', _vm._g(_vm._b({
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.Common.accountFilter'),
            "prepend-icon": "fa-filter",
            "solid-icon": Boolean(_vm.accountId)
          }
        }, 'core-button', attrs, false), on)) : _c('core-button', _vm._g(_vm._b({
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.Common.accountFilter'),
            "prepend-icon": "fa-filter",
            "solid-icon": Boolean(_vm.accountId)
          }
        }, 'core-button', attrs, false), on), [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Common.accountFilter')) + "\n      ")])];
      }
    }], null, false, 3573380466)
  }, [_c(VList, {
    attrs: {
      "dense": ""
    }
  }, [_c(VListItemGroup, {
    attrs: {
      "value": _vm.listSelection,
      "multiple": _vm.multiple,
      "color": _vm.color
    }
  }, [_c(VTextField, {
    staticClass: "mx-3 mt-1 mb-2",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.search'),
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.accountsSearchQuery,
      callback: function ($$v) {
        _vm.accountsSearchQuery = $$v;
      },
      expression: "accountsSearchQuery"
    }
  }), _vm._l(_vm.accountsQueryResult, function (account, idx) {
    return _c(VListItem, {
      key: idx,
      ref: `account_${account.id}`,
      refInFor: true,
      on: {
        "click": function ($event) {
          return _vm.clickedAccount(idx, account);
        }
      }
    }, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(account.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(account.id) + ")")])], 1)], 1);
  })], 2)], 1)], 1), _vm.showResetButton ? _c('core-button', {
    attrs: {
      "color": _vm.color,
      "title": _vm.$i18n_t('NiotaClassic.Common.undo'),
      "prepend-icon": "fa-undo"
    },
    on: {
      "click": function ($event) {
        _vm.accountsSearchQuery = null;
        _vm.selectedAccounts = [];
        _vm.filterAlert = false;
        _vm.filterWarning = false;
        _vm.$emit('reset-filter');
      }
    }
  }) : _vm._e()], 1) : _c(VMenu, {
    attrs: {
      "max-height": "400",
      "offset-y": "",
      "close-on-click": true,
      "close-on-content-click": false,
      "nudge-bottom": "4"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c('core-button', _vm._g(_vm._b({
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('NiotaClassic.Common.accountFilter'),
            "prepend-icon": "fa-filter",
            "active": Boolean(_vm.accountId)
          }
        }, 'core-button', attrs, false), on))];
      }
    }])
  }, [_c(VList, {
    attrs: {
      "dense": ""
    }
  }, [_c(VListItemGroup, {
    attrs: {
      "value": _vm.listSelection,
      "multiple": _vm.multiple,
      "color": _vm.color
    }
  }, [_c(VTextField, {
    staticClass: "mx-3 mt-1 mb-2",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('Common.search'),
      "hide-details": "",
      "dense": ""
    },
    model: {
      value: _vm.accountsSearchQuery,
      callback: function ($$v) {
        _vm.accountsSearchQuery = $$v;
      },
      expression: "accountsSearchQuery"
    }
  }), _vm._l(_vm.accountsQueryResult, function (account, idx) {
    return _c(VListItem, {
      key: idx,
      ref: `account_${account.id}`,
      refInFor: true,
      on: {
        "click": function ($event) {
          return _vm.clickedAccount(idx, account);
        }
      }
    }, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(account.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(account.id) + ")")])], 1)], 1);
  })], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };